<template>
  <div class="form-wrapper">
    <div class="form-container">
      <form @submit.prevent="handleForgotPassword">
        <div class="form-group">
          <label for="email">Email</label>
          <input
            id="email"
            v-model="email"
            type="email"
            placeholder="Ingrese su email"
            required
          />
        </div>
        <button class="main_button" type="submit" :disabled="loading">
          {{ loading ? "Cargando..." : "Recuperar" }}
        </button>
      </form>
    </div>
    <img :src="logo" alt="Logo" class="logo" />
    <ErrorPopup :errorMessage="error" />
</div>
</template>

<script setup>
  import { ref } from "vue";
  import { useLoadingStore } from "@/stores/loadingStore";

  import ErrorPopup from "@/components/common/ErrorPopup.vue";

  const error = ref(null);
  const email = ref("");
  const logo = require("@/assets/images/logo.png"); // Ruta de la imagen
  const loadingStore = useLoadingStore(); // Obtener acceso al store

  const handleForgotPassword = async () => {
    loadingStore.setLoading(true);
    error.value = null;

    try {
      const response = await fetch(process.env.VUE_APP_API_URL+"api/dashboard/auth/forgot_password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "vdas": process.env.VUE_APP_API_VDAS,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
        },
        body: JSON.stringify({
          "email": email.value,
        }),
      });

      if (!response.ok) {
        error.value = "Error en la autenticación";
      }

      const data = await response.json();

      error.value = data.message;

    } catch (_) {
      error.value = "Error en la comunicación, por favor, vuelve a intentarlo";
    } finally {
      loadingStore.setLoading(false);
    }
  };
</script>

<style scoped>

.logo {
  width: 100%;
  max-width: 450px;
  margin-top: 100px;
  padding-bottom: 10px;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}
</style>